import path from 'path';
import fs from 'fs-extra';
import chalk from 'chalk';

export async function updatePackageJson(
  dependencies: Record<string, string>,
  devDependencies: Record<string, string>
) {
  const packageJsonPath = path.join(process.cwd(), 'package.json');
  
  if (!await fs.pathExists(packageJsonPath)) {
    console.log(chalk.yellow('⚠️  No package.json found. You may need to run npm init first.'));
    return;
  }
  
  const packageJson = await fs.readJson(packageJsonPath);
  
  // Add dependencies
  if (Object.keys(dependencies).length > 0) {
    packageJson.dependencies = packageJson.dependencies || {};
    Object.assign(packageJson.dependencies, dependencies);
    console.log(chalk.blue('📦 Added dependencies:'), Object.keys(dependencies).join(', '));
  }
  
  // Add dev dependencies
  if (Object.keys(devDependencies).length > 0) {
    packageJson.devDependencies = packageJson.devDependencies || {};
    Object.assign(packageJson.devDependencies, devDependencies);
    console.log(chalk.blue('🔧 Added dev dependencies:'), Object.keys(devDependencies).join(', '));
  }
  
  await fs.writeJson(packageJsonPath, packageJson, { spaces: 2 });
  
  console.log(chalk.green('✅ package.json updated'));
  console.log(chalk.yellow('💡 Run npm install to install new dependencies'));
}